import AircraftDetails from './AircraftDetails';
export default AircraftDetails;
